import { render, staticRenderFns } from "./checkXMLUpload.vue?vue&type=template&id=2ee6b70f&scoped=true&"
import script from "./checkXMLUpload.vue?vue&type=script&lang=js&"
export * from "./checkXMLUpload.vue?vue&type=script&lang=js&"
import style0 from "./checkXMLUpload.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./checkXMLUpload.vue?vue&type=style&index=1&id=2ee6b70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee6b70f",
  null
  
)

export default component.exports